export default {
  modelingServiceData: (state) => state.modelingServiceData,
  modelingSelectedService: (state) => state.modelingSelectedService,
  modelingSelectedServiceDetails: (state) => state.modelingSelectedServiceDetails,
  modelingLogs: (state) => state.modelingLogs,
  modelingSound: (state) => parseInt(state.modelingSound) || parseInt(localStorage.getItem("modelingSound")) || 0,
  modelingSoundsMap: (state) => state.modelingSoundsMap,
  modelingSelectedSound: (state) => state.modelingSelectedSound || localStorage.getItem("modelingSelectedSound") || 'bell1',
  modelingNewWorkspaceCreated: (state) => state.modelingNewWorkspaceCreated,
  modelingSystemLimits: (state) => state.modelingSystemLimits,
  modelingNeedSystemLimits: (state) => state.modelingNeedSystemLimits,
};



// WEBPACK FOOTER //
// ./src/store/modeling/getters.js